const BASE_PATH = '/TrafficDirector/'

const BUTTONS = {
  START_SETUP: 'StartSetup',
  WATCH_VIDEO: 'WatchVideo',
  CLOSE_VIDEO: 'CloseVideo',
  CLOSE_NOT_LISTED: 'CloseNotListed',
  ACCOUNT_CHOICE: 'AccountChoice',
  LEARN_MORE: 'LearnMore',
  CLOSE_LEARN_MORE: 'CloseLearnMore',
  CLOSE_SETUP_MODE: 'CloseSetupMode',
  SETUP_USB: 'SetupUsb',
  CLOSE_USE_OFFLINE: 'CloseUseOffline',
  INSTALL_HP_SMART: 'InstallHpSmart',
  DOWNLOAD_DRIVERS: 'DownloadDrivers',
  CLOSE_TROUBLE_INSTALLING: 'CloseTroubleInstalling',
  CLOSE_SCANNING_FEATURES_NOTICE: 'CloseScanningFeaturesNotice',
  VIEW_ANIMATIONS: 'ViewAnimations',
  USE_USB: 'UseUsb',
  HP_SUPPORT: 'HpSupport',
  LANGUAGE_SELECTOR: 'LanguageSelector',
  SELECT_LANGUAGE: 'SelectLanguage',
  CLOSE_LANGUAGE_SELECTOR: 'CloseLanguageSelector',
  CLOSE_SWITCH_TO_MOBILE: 'CloseSwitchToAmobileDevice',
  ALIGNMENT_REDIRECT_TO_GET_HELP: 'AlignmentRedirectToGetHelp',
  INSTALL_HP_SOFTWARE: 'InstallHpSoftware'
}
const LINKS = {
  GO_123_HP: 'GoLinkHp123',
  CHECK_SETUP_MODE: 'CheckSetupMode',
  VIEW_INSTRUCTIONS: 'ViewInstructions',
  VIEW_THESE_INSTRUCTIONS: 'ViewTheseInstructions',
  HP_SUPPORT: 'HpSupport',
  PRINTER_SUPPORT_SITE: 'PrinterSupportSite',
  FULL_USER_GUIDE: 'FullUserGuide',
  TROUBLE_INSTALLING: 'TroubleInstalling',
  HP_PLUS: 'HpPlus',
  INSTANT_INK: 'InstantInk',
  TROUBLESHOOTING_AND_GUIDES: 'TroubleshootingGuides',
  GET_HELP: 'GetHelp'
}
export const ACTIVITY = {
  HARDWARE_SETUP: 'HardwareSetup-v01'
}

export const getSubOptionScreen = ({ subtabScreenName, selectedTab }) => {
  return {
    screenName: subtabScreenName,
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_TABS_PATH[selectedTab]
  }
}

export const getActionAuxParamsForAnalytics = (
  printerModel,
  paas,
  country,
  language,
  os,
  error,
  derivativeName
) => {
  const params = [
    `printerModel=${printerModel}`,
    `paas=${paas}`,
    `locale=${country?.toLowerCase?.()}-${language?.toLowerCase?.()}`,
    `derivativeName=${derivativeName || ''}`
  ]

  if (os) {
    params.push(`os=${os}`)
  }

  if (error) {
    params.push(`errorReason=${error}`)
  }

  return params.join('&')
}

export const ANALYTICS = {
  BUTTONS,
  LINKS,
  MODALS: {
    WATCH_VIDEO: {
      screenName: 'WatchVideo',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}LandingPage/`
    },
    LEARN_MORE: {
      screenName: 'LearnMore',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}AccountType/`
    },
    SETUP_MODE: {
      screenName: 'SetupMode',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}SetupChecklist/`
    },
    USE_OFFLINE: {
      screenName: 'UseOffline',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}SetupChecklist/`
    },
    PRINTER_NOT_LISTED: {
      screenName: 'PrinterNotListed',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}HpSoftwareTrillium/`
    },
    UNSUPPORTED_OS: {
      screenName: 'UnsupportedOs',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}HpSoftwareTrillium/`
    },
    HP_SMART_FEATURES: {
      screenName: 'HpSmartFeatures',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}HpSoftwareTrillium/`
    },
    HP_SMART_FEATURES_SKYLINE: {
      screenName: 'HpSmartFeatures',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}HpSoftwareSkyline/`
    },
    USE_OFFLINE_INSTALL_SOFTWARE: {
      screenName: 'UseOffline',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}InstallSoftware/`
    },
    SWITCH_TO_MOBILE: {
      screenName: 'SwitchToAmobileDevice',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}InstallSoftware/`
    },
    TROUBLE_INSTALLING: {
      screenName: 'TroubleInstalling',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}InstallSoftware/`
    },
    'power-on': {
      screenName: 'PowerOnModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}PowerOn/`
    },
    'install-ink': {
      screenName: 'InstallInkModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}InstallInk/`
    },
    'load-paper': {
      screenName: 'LoadPaperModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}LoadPaper/`
    },
    'hp-software': {
      screenName: 'HpSoftwareModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}HpSoftwareTrillium/`
    },
    alignment: {
      screenName: 'AlignmentModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}Alignment/`
    },
    purger: {
      screenName: 'PurgerModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}Purger/`
    },
    printheads: {
      screenName: 'PrintheadsModal##',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}Printheads/`
    },
    LANGUAGE_SELECTOR: {
      screenName: 'LanguageSelectorModal',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}LandingPage/`
    },
    wheres_product_name: {
      screenName: '',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}LandingPage/`
    },
    scanning_features_notice: {
      screenName: '',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}LandingPage/`
    }
  },
  SCREENS: {
    SETUP_TAB: {
      screenName: 'SetupTab',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    LEARN_TAB: {
      screenName: 'LearnTab',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    GET_HELP_TAB: {
      screenName: 'GetHelpTab',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    LANDING_PAGE: {
      screenName: 'LandingPage',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    INSTALL_UNSUPPORTED_OS: {
      screenName: 'InstallUnsupportedOs',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    INSTALL_CHINA: {
      screenName: 'InstallChina',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    PAGE_NOT_FOUND: {
      screenName: 'PageNotFound',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    'power-on': {
      screenName: 'PowerOn',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    'install-ink': {
      screenName: 'InstallInk',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    'load-paper': {
      screenName: 'LoadPaper',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    'hp-software': {
      screenName: 'HpSoftwareTrillium',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    'hp-software-skyline': {
      screenName: 'HpSoftwareSkyline',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    alignment: {
      screenName: 'Alignment',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    purger: {
      screenName: 'Purger',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    printheads: {
      screenName: 'Printheads',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    ACCOUNT_TYPE: {
      screenName: 'AccountType',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    SETUP_CHECKLIST: {
      screenName: 'SetupChecklist',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    CONNECT_USB: {
      screenName: 'ConnectUsb',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    UNSUPPORTED_OS: {
      screenName: 'UnsupportedOs',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    SET_UP_CHROMEBOOK: {
      screenName: 'SetUpChromebook',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    SET_UP_LINUX: {
      screenName: 'SetUpLinux',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    SELECT_USB: {
      screenName: 'SelectUsb',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    INSTALL_DRIVER: {
      screenName: 'InstallDriver',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    INSTALL_DRIVER_INTRANET: {
      screenName: 'InstallDriverIntranet',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    DRIVER_NOT_FOUND: {
      screenName: 'NoDriverFound',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    DOWNLOADING_DRIVER: {
      screenName: 'DownloadingDriver',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    DRIVER_SUCCESS: {
      screenName: 'DriverSuccess',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    INSTALL_SOFTWARE: {
      screenName: 'InstallSoftware',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    FINISH_SETUP_BUSINESS: {
      screenName: 'FinishSetupSmb',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    SKIP_INTERNET_CONNECTION: {
      screenName: 'SkipInternetConnection',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    START_AIRPRINT: {
      screenName: 'StartPrintingWithAirPrint',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    STAR_PRINTING_MOBILE: {
      screenName: 'MobileInstallation',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    HP_SMART_INSTALLATION: {
      screenName: 'HpSmartInstallation',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: `${BASE_PATH}GetHelp/`
    },
    PRIVACY_FOOTER: {
      screenName: 'PrivacyFooter',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    SEARCH_PAGE: {
      screenName: 'SearchPage',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    },
    UNABLE_TO_FIND_PAGE: {
      screenName: 'UnableToFindPage',
      activity: ACTIVITY.HARDWARE_SETUP,
      screenPath: BASE_PATH
    }
  },
  VERSION: '1.4.0',
  ENVELOPE_VERSION: '1.4.0',
  EVENT_DETAIL_TYPE:
    'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1',
  EVENT_CATEGORY: 'simpleUi'
}

export const ANALYTICS_TABS_PATH = [
  `${BASE_PATH}Setup/`,
  `${BASE_PATH}Learn/`,
  `${BASE_PATH}GetHelp/`
]
